import { connect } from 'react-redux'
import { pageToggleRight, legislationReferenceSetHighlighted } from 'redux/actions'
import LegislationReferenceComponent from 'components/legislation-reference/LegislationReferenceComponent'

const mapStateToProps = state => ({
  aol: state.aol.name
})

const mapDispatchToProps = dispatch => ({
  pageToggleRight: force => dispatch(pageToggleRight(force)),
  setHighlighted: highlighted => dispatch(legislationReferenceSetHighlighted(highlighted))
})

export default connect(mapStateToProps, mapDispatchToProps)(LegislationReferenceComponent)
